import React from "react";
import PageBanner from "../components/PageBanner";
import { HERO_IMAGES } from "../mock";

const History = () => {
  const milestones = [
    { year: "1998", text: "GPM Classics founded from a lifelong passion for fine motorcars." },
    { year: "2006", text: "Opened our dedicated showroom and restoration workshop." },
    { year: "2014", text: "Introduced secure, climate-controlled storage for clients." },
    { year: "2024", text: "Recognised as one of the region's most trusted classic car specialists." },
  ];
  return (
    <div className="bg-white">
      <PageBanner title="Our History" subtitle="Decades of dedication to the world's finest classic cars." image={HERO_IMAGES[0]} />
      <div className="max-w-4xl mx-auto px-6 py-16">
        <p className="gpm-text-gold uppercase tracking-[0.3em] text-xs mb-3">Our Story</p>
        <h2 className="font-serif-display text-3xl md:text-4xl font-bold gpm-text-green mb-6">A Passion Passed Down Through Generations</h2>
        <div className="gpm-divider mb-8" />
        <p className="text-gray-600 leading-relaxed mb-5">
          GPM Classics began with a simple belief: that a beautiful car deserves to be cherished. What started
          as a private collection soon grew into one of the most respected names in the classic car world,
          built on honesty, expertise and an unwavering eye for quality.
        </p>
        <p className="text-gray-600 leading-relaxed mb-12">
          Today we buy, sell, store and celebrate exceptional motorcars from every era. Our clients return
          time and again because we treat every car — and every customer — as if it were our own.
        </p>

        <div className="space-y-8">
          {milestones.map((m) => (
            <div key={m.year} className="flex gap-6">
              <div className="font-serif-display text-3xl font-bold gpm-text-gold w-20 shrink-0">{m.year}</div>
              <div className="border-l-2 gpm-border-gold pl-6 pb-2">
                <p className="text-gray-700">{m.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
